package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Macao Flag (32x24dp)
 *
 * - ISO Alpha-2: MO
 * - ISO Alpha-3: MAC
 * - ISO Numeric: 446
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.Macao: ImageVector by lazy {
    ImageVector.Builder(
        name = "Macao:MO:MAC:446:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF1C9975)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.022f, 6.854f)
                lineTo(14.388f, 7.84f)
                lineTo(14.76f, 5.915f)
                lineTo(13.4f, 4.475f)
                lineTo(15.242f, 4.397f)
                lineTo(16.022f, 2.6f)
                lineTo(16.801f, 4.397f)
                horizontalLineTo(18.64f)
                lineTo(17.283f, 5.915f)
                lineTo(17.691f, 7.84f)
                lineTo(16.022f, 6.854f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.383f, 7.584f)
                lineTo(10.372f, 8.194f)
                lineTo(10.603f, 7.004f)
                lineTo(9.762f, 6.114f)
                lineTo(10.901f, 6.065f)
                lineTo(11.383f, 4.954f)
                lineTo(11.865f, 6.065f)
                horizontalLineTo(13.002f)
                lineTo(12.162f, 7.004f)
                lineTo(12.415f, 8.194f)
                lineTo(11.383f, 7.584f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(20.581f, 7.584f)
                lineTo(19.571f, 8.194f)
                lineTo(19.801f, 7.004f)
                lineTo(18.96f, 6.114f)
                lineTo(20.099f, 6.065f)
                lineTo(20.581f, 4.954f)
                lineTo(21.063f, 6.065f)
                horizontalLineTo(22.2f)
                lineTo(21.361f, 7.004f)
                lineTo(21.613f, 8.194f)
                lineTo(20.581f, 7.584f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.766f, 9.611f)
                lineTo(7.956f, 10.1f)
                lineTo(8.141f, 9.145f)
                lineTo(7.466f, 8.43f)
                lineTo(8.38f, 8.392f)
                lineTo(8.766f, 7.5f)
                lineTo(9.153f, 8.392f)
                horizontalLineTo(10.066f)
                lineTo(9.392f, 9.145f)
                lineTo(9.595f, 10.1f)
                lineTo(8.766f, 9.611f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(23.561f, 9.611f)
                lineTo(22.75f, 10.1f)
                lineTo(22.935f, 9.145f)
                lineTo(22.26f, 8.43f)
                lineTo(23.174f, 8.392f)
                lineTo(23.561f, 7.5f)
                lineTo(23.948f, 8.392f)
                horizontalLineTo(24.86f)
                lineTo(24.187f, 9.145f)
                lineTo(24.389f, 10.1f)
                lineTo(23.561f, 9.611f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(16f, 22f)
                curveTo(20.418f, 22f, 24f, 18.418f, 24f, 14f)
                curveTo(24f, 9.582f, 20.418f, 6f, 16f, 6f)
                curveTo(11.582f, 6f, 8f, 9.582f, 8f, 14f)
                curveTo(8f, 18.418f, 11.582f, 22f, 16f, 22f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.681f, 21.064f)
                horizontalLineTo(19.319f)
                verticalLineTo(22.136f)
                horizontalLineTo(12.681f)
                verticalLineTo(21.064f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.957f, 19.46f)
                horizontalLineTo(22.723f)
                verticalLineTo(20.443f)
                horizontalLineTo(9.957f)
                verticalLineTo(19.46f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(12.62f, 19.021f)
                horizontalLineTo(8.716f)
                verticalLineTo(18.021f)
                lineTo(12.613f, 18.021f)
                curveTo(13.994f, 18.001f, 15.003f, 17.607f, 15.676f, 16.848f)
                lineTo(16.011f, 16.47f)
                lineTo(16.386f, 16.81f)
                curveTo(17.285f, 17.625f, 18.183f, 18.021f, 19.091f, 18.021f)
                horizontalLineTo(23.396f)
                verticalLineTo(19.021f)
                horizontalLineTo(19.091f)
                curveTo(18.048f, 19.021f, 17.04f, 18.628f, 16.077f, 17.859f)
                curveTo(15.223f, 18.616f, 14.065f, 19f, 12.62f, 19.021f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFFF7FCFF)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(16.035f, 7.608f)
            curveTo(16.035f, 7.608f, 14.326f, 9.296f, 14.326f, 11.612f)
            curveTo(14.326f, 12.108f, 14.404f, 12.576f, 14.527f, 13.006f)
            curveTo(13.977f, 11.786f, 13.939f, 10.463f, 14.414f, 9.02f)
            lineTo(13.767f, 8.807f)
            curveTo(13.284f, 10.275f, 13.281f, 11.656f, 13.761f, 12.935f)
            curveTo(12.769f, 12.337f, 11.627f, 11.935f, 10.455f, 11.805f)
            lineTo(10.38f, 12.482f)
            curveTo(11.404f, 12.595f, 12.404f, 12.937f, 13.282f, 13.443f)
            curveTo(13.065f, 13.355f, 12.838f, 13.279f, 12.601f, 13.219f)
            curveTo(10.438f, 12.667f, 8.316f, 13.449f, 8.316f, 13.449f)
            curveTo(8.316f, 13.449f, 9.54f, 16.196f, 11.911f, 16.601f)
            curveTo(12.029f, 16.621f, 12.146f, 16.636f, 12.261f, 16.648f)
            lineTo(12.243f, 16.648f)
            curveTo(11.113f, 16.648f, 10.062f, 16.186f, 9.077f, 15.247f)
            lineTo(8.607f, 15.74f)
            curveTo(9.713f, 16.794f, 10.929f, 17.329f, 12.243f, 17.329f)
            curveTo(13.528f, 17.329f, 14.722f, 16.818f, 15.813f, 15.809f)
            curveTo(15.988f, 15.703f, 16.09f, 15.627f, 16.107f, 15.615f)
            lineTo(16.149f, 15.651f)
            curveTo(16.127f, 15.69f, 16.116f, 15.711f, 16.116f, 15.711f)
            curveTo(16.116f, 15.711f, 16.223f, 15.776f, 16.417f, 15.868f)
            curveTo(17.494f, 16.703f, 18.841f, 17.329f, 19.907f, 17.329f)
            curveTo(21.222f, 17.329f, 22.438f, 16.794f, 23.543f, 15.74f)
            lineTo(23.073f, 15.247f)
            curveTo(22.089f, 16.186f, 21.038f, 16.648f, 19.907f, 16.648f)
            curveTo(19.494f, 16.648f, 19.09f, 16.582f, 18.693f, 16.448f)
            curveTo(19.249f, 16.478f, 19.861f, 16.428f, 20.495f, 16.234f)
            curveTo(22.83f, 15.52f, 23.804f, 13.361f, 23.804f, 13.361f)
            curveTo(23.804f, 13.361f, 22.561f, 12.69f, 20.983f, 12.683f)
            curveTo(21.337f, 12.592f, 21.706f, 12.525f, 22.09f, 12.482f)
            lineTo(22.016f, 11.805f)
            curveTo(20.535f, 11.969f, 19.255f, 12.469f, 18.18f, 13.302f)
            curveTo(18.809f, 11.921f, 18.857f, 10.417f, 18.327f, 8.807f)
            lineTo(17.681f, 9.02f)
            curveTo(18.114f, 10.335f, 18.12f, 11.551f, 17.701f, 12.68f)
            curveTo(17.773f, 12.346f, 17.815f, 11.989f, 17.815f, 11.612f)
            curveTo(17.815f, 9.17f, 16.035f, 7.608f, 16.035f, 7.608f)
            close()
            moveTo(16.786f, 14.755f)
            lineTo(16.761f, 14.792f)
            lineTo(16.792f, 14.755f)
            lineTo(16.786f, 14.755f)
            close()
            moveTo(15.135f, 14.596f)
            lineTo(15.202f, 14.534f)
            curveTo(15.263f, 14.635f, 15.323f, 14.731f, 15.383f, 14.819f)
            curveTo(15.306f, 14.747f, 15.223f, 14.672f, 15.135f, 14.596f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun MacaoPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.Macao,
            contentDescription = "Macao Flag"
        )
    }
}
